"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledChevron = exports.StyledSelectField = exports.StyledSelectDropdown = void 0;
const componentlibrary_1 = require("@emarketer/componentlibrary");
const styled_components_1 = require("styled-components");
const Chevron_1 = __importDefault(require("../Chevron"));
exports.StyledSelectDropdown = styled_components_1.styled.div `
  display: flex;
  border: 1px solid ${({ $isError }) => ($isError ? componentlibrary_1.COLOR.II.RED.DEFAULT : componentlibrary_1.COLOR.II.GRAY.GRAY200)};
  height: fit-content;
  border-radius: 48px;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 24px;
  svg {
    margin-right: 24px;
  }
`;
exports.StyledSelectField = styled_components_1.styled.select `
  -webkit-outline: none;
  -moz-outline: none;
  -webkit-outline: none;
  outline: none;
  :focus {
    outline: none;
  }
  border: none;
  width: 100%;
  margin: 12px 24px 12px 22px; // It looks like there is 2px padding on the left from options
  font-size: 16px;
  font-style: normal;
  font-weight: 300;
  line-height: 28.8px; /* 180% */
  color: ${componentlibrary_1.COLOR.II.GRAY.DARK};
  @media (min-width: 600px) {
    margin: 0px 0px 0px 22px; // It looks like there is 2px padding on the left from options
  }
  appearance: none;
  background: none;
  padding-right: 30px; /* Adjust padding to make space for the Chevron */
  position: relative;
`;
exports.StyledChevron = (0, styled_components_1.styled)(Chevron_1.default) `
  margin-right: 24px;
`;
